(() => {
  if (customElements.get('rp-design-upload')) return;
  customElements.define('rp-design-upload', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.info = this.closest('product-info');
      this.button = this.querySelector('[data-upload-design]');
      this.widgetHost = this.querySelector('[data-upload-widget]');
      this.status = this.querySelector('[data-upload-status]');
      this.button.addEventListener('click', () => {
        this.sync();
        const input = this.querySelector('input.ymq-options-file-input[type="file"]');
        if (input && !this.button.disabled) input.click();
      }, { signal: this.abort.signal });
      this.addEventListener('keydown', event => {
        const remove = event.target.closest('.ymq_upload_file_item_del');
        if (remove && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          remove.click();
        }
      }, { signal: this.abort.signal });
      // Keep YMQ's real inputs, file previews, delete handlers and upload state.
      // Moving the complete widget preserves its delegated event boundaries.
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.info, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','disabled'] });
      this.timeout = setTimeout(() => {
        if (!this.button.disabled) return;
        this.status.textContent = 'Design upload is not ready. Please reload the page or contact us for help.';
        this.status.hidden = false;
      }, 10000);
      this.sync();
    }
    sync() {
      const widget = this.info.querySelector('#ymq-box');
      const input = widget?.querySelector('input.ymq-options-file-input[type="file"]');
      if (!input) { if(!this.button.disabled)this.button.disabled = true; return; }
      if (widget.parentElement !== this.widgetHost) this.widgetHost.append(widget);
      const control=input.closest('.ymq_upload_new');
      const uploading=control?.classList.contains('ymq-btn-progress');
      const full=control?.classList.contains('ymq_disabled');
      const disabled=!!(input.disabled || uploading || full);
      if(this.button.disabled!==disabled)this.button.disabled=disabled;
      const label=this.querySelector('[data-upload-label]'),text=uploading?'Uploading…':full?'Upload limit reached':'Upload Design';
      if(label.textContent!==text)label.textContent=text;
      if(!this.classList.contains('rp-design-upload-ready'))this.classList.add('rp-design-upload-ready');
      this.decoratePreviews(widget);
      if(!this.status.hidden)this.status.hidden=true;
      clearTimeout(this.timeout);
    }
    decoratePreviews(widget) {
      for (const item of widget.querySelectorAll('.ymq_upload_file_item')) {
        const remove = item.querySelector('.ymq_upload_file_item_del');
        if (!remove || remove.dataset.rpDeleteReady) continue;
        const image = item.querySelector('.ymq_img_item');
        const entry = window.ymq_option?.productInstance?.upload?.fileData?.[remove.dataset.name]?.[remove.dataset.num];
        let name = item.querySelector('.ymq_upload_name');
        if (!name) {
          name = this.ownerDocument.createElement('span');
          name.className = 'ymq_upload_name';
          const source = image?.getAttribute('src') || '';
          let filename = '';
          if (/^https?:/.test(source)) {
            try { filename = decodeURIComponent(new URL(source).pathname.split('/').pop()); } catch {}
          }
          name.textContent = entry?.file?.name || entry?.name || filename || 'Design image';
          item.append(name);
        }
        if (image) image.alt = name.textContent;
        // Retain the original YMQ delete element and its file keys: its handler
        // removes the actual queued file / cart property as well as the preview.
        remove.dataset.rpDeleteReady = 'true';
        remove.setAttribute('role', 'button');
        remove.setAttribute('tabindex', '0');
        remove.setAttribute('aria-label', `Remove ${name.textContent}`);
        remove.setAttribute('title', 'Remove file');
        remove.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 10v7M14 10v7"/></svg>';
        item.append(remove);
      }
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      this.observer?.disconnect(); clearTimeout(this.timeout);
    }
  });
})();
